/* @flow weak */
import Columns from 'components/Columns.jsx';
import cx from 'classnames';
import React from 'react';
import DialogWithSidebar from 'components/DialogWithSidebar.jsx';
import DialogSidebar from 'components/DialogSidebar.jsx';
import Tabs from 'components/Tabs.jsx';

import './styles/LeftTabModal.scss';

class LeftTabModal extends React.Component {
  static propTypes = {
    onRequestHide: React.PropTypes.func.isRequired,
    sidebarHeader: React.PropTypes.node.isRequired,
    children: React.PropTypes.node.isRequired,
    tabActive: React.PropTypes.number,
    onTabChange: React.PropTypes.func,
    onMaskHide: React.PropTypes.func,
    onDialogClick: React.PropTypes.func,
    sidebarFooter: React.PropTypes.node,
    hideOnBlur: React.PropTypes.bool,
  };

  static contextTypes = {
    router: React.PropTypes.object.isRequired,
  };

  static defaultProps = {
    tabActive: 0,
    onTabChange: () => {},
    hideOnBlur: false,
  };

  render() {
    return (
      <DialogWithSidebar
        {...this.props}
        className={cx('LeftTabModal', this.props.className)}
        hideOnBlur={this.props.hideOnBlur}
        onMaskHide={this.props.onMaskHide}
        onClick={this.props.onDialogClick}
        size="large">
        <Columns>
          <DialogSidebar color="grey">
            {this.props.sidebarHeader}
            {this.props.sidebarFooter &&
              <div className="LeftTabModal-footer">{this.props.sidebarFooter}</div>}
          </DialogSidebar>
          <Tabs
            center
            tabActive={this.props.tabActive}
            className="LeftTabModal-body"
            onTabChange={this.props.onTabChange}>
            {this.props.children}
          </Tabs>
        </Columns>
      </DialogWithSidebar>
    );
  }
}

export default LeftTabModal;



// WEBPACK FOOTER //
// ./src/components/LeftTabModal.jsx